
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import epicService from '@/services/epic.service';

  @Component({
    computed: {
      ...mapGetters([
        'redirectUrl'
      ])
    }
  })
  export default class EpicGamesLink extends Vue {
    data() {
      return {
        useSEGARedeemer: false,
      }
    }
    created() {
      this.$data.useSEGARedeemer = this.$data.RCEnvironment.VUE_APP_USE_SEGA_REDEEMER == true;
      epicService.goToEpicGames(this, this.$data.useSEGARedeemer, this.$store.getters.redirectUrl);
    }
  }
